module.exports = __webpack_public_path__ + "media/images/official/about_exchange-de4081d42a5d827de01a10c1cf0eef5e.jpg";